module.exports = __webpack_public_path__ + "img/curva login.ec27fb0d.png";